import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({ /*integration, */ login, action }) => (
	<div className="integration integration__oauth--linkedIn">
		<button onClick={login}>
			<FormattedMessage id={`auth.${action}.integration.oauth.linked-in`} tagName={React.Fragment} />
		</button>
	</div>
);
